import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Organization } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_ORGANIZATION_BY_ID_KEY = 'get-all-organizations';

export const useGetOrganizationByID = (orgID: number) =>
  usePermittedQuery<Organization>(
    [ACCOUNT_TYPE.ADMIN, ACCOUNT_TYPE.ORG_ADMIN],
    () => `/organization/${orgID}`,
    {},
    [GET_ORGANIZATION_BY_ID_KEY],
    {
      enabled: orgID > 0 && typeof orgID === 'number',
    },
  );
